import { render, staticRenderFns } from "./FreeBlindboxSection.vue?vue&type=template&id=3193cb56&scoped=true"
import script from "./FreeBlindboxSection.vue?vue&type=script&lang=js"
export * from "./FreeBlindboxSection.vue?vue&type=script&lang=js"
import style0 from "./FreeBlindboxSection.vue?vue&type=style&index=0&id=3193cb56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3193cb56",
  null
  
)

export default component.exports